const desktopImageSizes = {
  imageSizes: [
    {
      mediaQuery: '(min-width: 2400px)',
      imageWidth: 3136,
    },
    {
      mediaQuery: '(min-width: 2048px)',
      imageWidth: 2336,
    },
    {
      mediaQuery: '(min-width: 1920)',
      imageWidth: 1984,
    },
    { mediaQuery: '(min-width: 1200px)', imageWidth: 1568 },
    {
      mediaQuery: '(min-width: 1024px)',
      imageWidth: 1168,
    },
    {
      mediaQuery: '',
      imageWidth: 992,
    },
  ],
  fileExtension: 'jpg',
  progressive: true,
  quality: 85,
};

const mobileImageSizes = {
  imageSizes: [
    {
      mediaQuery: '(min-width: 980px)',
      imageWidth: 1536,
    },
    {
      mediaQuery: '(min-width: 640px)',
      imageWidth: 980,
    },
    {
      mediaQuery: '(min-width: 480px)',
      imageWidth: 640,
    },
    {
      mediaQuery: '(min-width: 320px)',
      imageWidth: 480,
    },
    {
      mediaQuery: '',
      imageWidth: 320,
    },
  ],
  fileExtension: 'jpg',
  progressive: true,
  quality: 85,
};

export { desktopImageSizes, mobileImageSizes };
